import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { QuantifyVisualisationType } from 'generated/graphql';

export const useIsAnomaliesTrendVisible = () => {
  const isAnomaliesTrendVisible = useQuantifyStore(
    ({ query: { shouldShowAnomalies, visualisationType } }) =>
      shouldShowAnomalies &&
      visualisationType === QuantifyVisualisationType.Trend,
  );

  return isAnomaliesTrendVisible;
};
